import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import Seo from "@/components/Seo";

export default function PaymentCancel() {
  const { t } = useApp();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-[70vh] pt-32 md:pt-40 pb-24 px-5 md:px-10 flex flex-col items-center justify-center text-center" data-testid="payment-cancel-page">
      <Seo title={t.seo.cancel.title} description={t.seo.cancel.description} noindex />
      <h1 className="font-display text-5xl md:text-6xl mb-4">{t.payment.cancelTitle}</h1>
      <p className="text-ink/60 font-light max-w-md mx-auto mb-8">{t.payment.cancelMsg}</p>
      <Link to="/payment" className="inline-block bg-ink text-paper px-8 py-4 text-xs uppercase tracking-[0.2em] transition-colors duration-500 hover:bg-accent hover:text-ink" data-testid="cancel-retry">{t.payment.payButton}</Link>
    </div>
  );
}
